import React, { useEffect, useState } from 'react';
import { useOpts } from '../../../context';
import BankInfoInput from './BankInfoInput';
import BankInfoReview from './BankInfoReview';
function BankInfo(_a) {
    var onSubmit = _a.onSubmit;
    var _b = useState(0), page = _b[0], setPage = _b[1];
    var setNavigateBack = useOpts().setNavigateBack;
    useEffect(function () {
        setNavigateBack(function () { return (page ? function () { return setPage(0); } : null); });
    }, [page, setNavigateBack]);
    if (page === 0)
        return React.createElement(BankInfoInput, { onContinue: function () { return setPage(1); } });
    return React.createElement(BankInfoReview, { onContinue: onSubmit });
}
export default BankInfo;
